import _ from 'lodash';
import React from 'react';
import { List } from 'immutable';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import ShoppingCart from '../../models/ShoppingCart';
import Store from '../../models/Store';
import Customer from '../../models/Customer';
import { RequestStates } from '../../stores/PaginatedStore';
import CustomerStore from '../../stores/CustomerStore';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import ShoppingCartStore from '../../stores/ShoppingCartStore';
import InventoryRecordActions from '../../actions/InventoryRecordActions';
import InventoryRecordsList from '../InventoryRecordsList';
import InventoryRecordCard from '../InventoryRecordCard';
import { DetailsPositions, PhotoPositions } from '../InventoryRecordListElement';
import styles from './index.sass';

export const UnitTypes = {
  Summary: 'summary',
  Photo: 'photo'
};

class SimilarProductsSection extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  static propTypes = {
    inventoryRecordId: React.PropTypes.string.isRequired,
    shoppingCart: React.PropTypes.instanceOf(ShoppingCart),
    store: React.PropTypes.instanceOf(Store),
    unitType: React.PropTypes.oneOf(_.values(UnitTypes)),
    showLoadingIndicator: React.PropTypes.bool,
    showSeparator: React.PropTypes.bool,
    similarProductCategories: React.PropTypes.instanceOf(List),
    similarProductCategoriesRequestStatus: React.PropTypes.string,
    customer: React.PropTypes.instanceOf(Customer)
  };

  static defaultProps = {
    unitType: UnitTypes.Summary,
    showLoadingIndicator: false,
    showSeparator: true
  };

  componentDidMount() {
    this.fetchSimilarProducts();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.inventoryRecordId !== this.props.inventoryRecordId) {
      this.fetchSimilarProducts();
    }
  }

  fetchSimilarProducts() {
    if('undefined' !== typeof window) {
      this.context.executeAction(InventoryRecordActions.fetchSimilar, {id: this.props.inventoryRecordId});
    }
  }

  renderCategory(similarProductCategory, i) {
    let list, listProps;
    let { store, shoppingCart, customer, unitType } = this.props;
    let isMobile = this.context.getUserAgent().isMobile;
    switch(unitType) {
      case UnitTypes.Summary:
        listProps = {
          className: styles.similarInventoryRecordsList,
          storeId: store.id,
          inventoryRecords: similarProductCategory.inventory_records,
          loading: false,
          emptyText: null,
          inventoryRecordsListElementConfig: {
            className: styles.similarInventoryRecordsListElement,
            photoClassName: styles.similarInventoryRecordsListElementPhoto,
            photoPosition: isMobile ? PhotoPositions.Right : PhotoPositions.Left,
            detailsPosition: isMobile ? DetailsPositions.Top : DetailsPositions.Middle,
            showRatings: true,
            showFeaturedBadge: false,
            showBuyButton: true,
            showHeartButton: false,
            showDescription: false,
            showVariantPriceLine: false
          }
        };
        list = <InventoryRecordsList {...listProps} />;
        break;
      case UnitTypes.Photo:
        list = (
          <div className={styles.listWrapper}>
            <div className={styles.listScrollContainer}>
              <div className={styles.list}>
                {similarProductCategory.inventory_records.map((inventoryRecord, ii) => {
                  let item = shoppingCart.findItemByInventoryRecordId(inventoryRecord.id);
                  let cardProps = {
                    key: ii,
                    inventoryRecord,
                    item,
                    store,
                    customer
                  };
                  return <InventoryRecordCard {...cardProps} />;
                })}
              </div>
            </div>
          </div>
        );
        break;
    }
    return (
      <div className={styles.similarInventoryRecords} key={i}>
        <p className={styles.header}>{similarProductCategory.header}</p>
        {list}
      </div>
    );
  }

  renderCategories(similarProductCategories) {
    return similarProductCategories.map(this.renderCategory.bind(this));
  }

  render() {
    let { similarProductCategories, similarProductCategoriesRequestStatus } = this.props;
    if(this.props.showLoadingIndicator && similarProductCategoriesRequestStatus === RequestStates.Loading) {
      return <span className="loading-spinner--teal" style={{display: 'block', margin: '60px auto'}} />;
    }
    if(!similarProductCategories || !similarProductCategories.size) {return null;}

    return (
      <div className={styles.categories}>
        {this.props.showSeparator ? <div className={styles.separator} /> : null }
        {this.renderCategories(similarProductCategories)}
      </div>
    );
  }
}

SimilarProductsSection = connectToStores(SimilarProductsSection, [InventoryRecordStore, CustomerStore, ShoppingCartStore], (context, props) => {
  let inventoryRecordStore = context.getStore(InventoryRecordStore);
  return {
    customer: context.getStore(CustomerStore).getCurrentCustomer(),
    shoppingCart: context.getStore(ShoppingCartStore).getShoppingCartByStoreId(props.store.id),
    similarProductCategories: inventoryRecordStore.getSimilarProductsCategoriesByInventoryRecordId(props.inventoryRecordId),
    similarProductCategoriesRequestStatus: inventoryRecordStore.getSimilarProductsCategoriesRequestStatusByInventoryRecordId(props.inventoryRecordId)
  };
});

export default SimilarProductsSection;



// WEBPACK FOOTER //
// banquet/components/SimilarProductsSection/index.js